"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const user_role_types_1 = require("./user-role.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataGridRoleMapping: [],
    dataMobileWeb: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        name: '',
        accessLevel: '',
        authorization: [],
        is_active: true,
        modified_by: '',
        modified_date: new Date(),
        created_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const userRoleReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [user_role_types_1.userRoleTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count, dataGridRoleMapping, dataMobileWeb } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid,
            dataGridRoleMapping,
            dataMobileWeb, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [user_role_types_1.userRoleTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [user_role_types_1.userRoleTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [user_role_types_1.userRoleTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false });
    },
    [user_role_types_1.userRoleTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, dataItem: dataItem ? dataItem : initialState.dataItem, mutationMode: mutationMode });
    },
    [user_role_types_1.userRoleTypes.ON_DELETE]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, mutationMode: false });
    },
    [user_role_types_1.userRoleTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === dataItem.id)
                    return dataItem;
                return item;
            }) });
    },
    [user_role_types_1.userRoleTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
});
exports.default = userRoleReducer;
